import { useMutation, useQuery } from '@apollo/react-hooks';
import React, { useEffect } from 'react';
import { DialogForm } from '../../components/DialogForm';
import { NOTIFICATION_RULE_QUERY, FETCH_NOTIFICATION_QUERY } from '../graphQL/queries';
import AddNotificationFormDataConfig from './formDataConfig';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';

type specObj = {
  notificationName: string;
  timeSpan: number;
  thresholdValue: number;
  notificationMessage: string;
  thresholdType: string;
  thresholdLimit: number;
  thresholdMet: any;
  email: string;
  id: any;
  searchPeriod: any;
  filterRule: any;
};

type responseObj = {
  GetNotificationData: specObj[];
};

interface CreateNotificationDialogProps {
  dialogOpen?: true | false;
  handleDialogClose?: any;
  handleDialogSubmit?: any;
  edit?: true | false;
  formData?: any;
  refresh?: any;
  formInfo?: any;
  createNotificationDialog?: true | false;
  handleCreateNotificationDialogSubmit?: any;
  filterCriteria?: any;
  filterRule?: any;
  rowId?: any;
  participantCode?: any;
  errorCode?: any;
  supportUser?: true | false;
}

let dataConfig = [...AddNotificationFormDataConfig];

const CreateNotificationDialog = (props: CreateNotificationDialogProps) => {
  const [notificationRule] = useMutation(NOTIFICATION_RULE_QUERY);
  // const { refetch } = useQuery<responseObj, {}>(FETCH_NOTIFICATION_QUERY, {
  //   variables: { participant: props.participantCode ? props.participantCode : 'ADMIN' }
  // });
  const { edit, formData } = props;
  const [notificationValueDisable, setNotificationValueDisable] = React.useState(false);
  const [formInfo, setFormInfo] = React.useState<any>({});
  const { enqueueSnackbar } = useSnackbar();

  const isPresent = (key: string) => {
    return props.filterCriteria && props.filterCriteria[key] && props.filterCriteria[key].length > 0;
  };

  const toColonSperated = (key: string) => {
    if (key === 'operations') return props.filterCriteria[key].map((val: any) => val?.value?.trim()).join(':');
    else return props.filterCriteria[key].map((val: string) => val.trim()).join(':');
  };
  let search: any = {};
  if (isPresent('operations')) {
    search.operation = toColonSperated('operations');
  }

  if (isPresent('loadIds')) {
    search.uniqueCustomerTransactionId = toColonSperated('loadIds');
  }

  if (isPresent('providerLoadIds')) {
    search.uniqueProviderTransactionId = toColonSperated('providerLoadIds');
  }

  if (isPresent('customerCodes')) {
    search.customerCode = toColonSperated('customerCodes');
  }

  if (isPresent('providerCodes')) {
    search.providerCode = toColonSperated('providerCodes');
  }

  if (isPresent('responseStatus')) {
    search.responseStatus = toColonSperated('responseStatus');
  }

  if (isPresent('providerCustomerCodes')) {
    search.providerCustomerCode = toColonSperated('providerCustomerCodes');
  }

  if (isPresent('statusCodes')) {
    search.statusCode = toColonSperated('statusCodes');
  }
  if (isPresent('timeTaken')) {
    search.timeTaken = toColonSperated('timeTaken');
  }
  if (isPresent('retryCount')) {
    search.retryCount = toColonSperated('retryCount');
  }
  if (isPresent('requestType')) {
    search.requestType = toColonSperated('requestType');
  }

  search = Object.keys(search)
    .map(key => {
      return key + '=' + search[key];
    })
    .join(',');

  useEffect(() => {
    if (props.edit) {
      if (formData) {
        formData.thresholdMet = formData.thresholdMet === true ? 'yes' : 'no';
        formData.filterRule = formData.filterRule === undefined ? '' : formData.filterRule.split('search=')[1];
      }
      if (formData.thresholdType === 'VALUE') {
        setNotificationValueDisable(true);
        const editData: any[] = [];
        (dataConfig || []).forEach((obj: any) => {
          let temp = { ...obj };
          if (temp.key === 'thresholdValue') {
            temp.disabled = true;
          }
          editData.push(temp);
        });
        dataConfig = [...editData];
      }

      setFormInfo({
        thresholdMet: formData.thresholdMet === true ? 'yes' : 'no',
        id: formData.id
      });
    } else {
      setFormInfo({
        ...props.formInfo
      });
    }
  }, [formData, props.edit, props.formInfo]);

  const handleNotificationClose = () => {
    props.handleDialogClose();
    setNotificationValueDisable(false);
  };

  const handleNotificationSubmit = (formDataObj: any) => {
    props.handleCreateNotificationDialogSubmit();
    notificationRule({
      variables: {
        notificationName: formDataObj.notificationName,
        timeSpan: formDataObj.timeSpan,
        thresholdValue: formDataObj.thresholdValue ? formDataObj.thresholdValue : 0,
        thresholdLimit: formDataObj.thresholdLimit,
        thresholdType: formDataObj.thresholdType,
        filterRule: edit ? props.filterRule : 'search=' + formDataObj.filterRule,
        notificationMessage: formDataObj.notificationMessage,
        searchPeriod: formDataObj.searchPeriod,
        thresholdMet: formDataObj.thresholdMet === 'yes' ? true : false,
        email: formDataObj.email,
        id: props.rowId,
        participant: props.participantCode === undefined ? 'ADMIN' : props.participantCode,
        webhookUrl: formDataObj?.webhookUrl,
        method: edit ? 'PUT' : 'POST'
      }
    })
      .then(response1 => {
        enqueueSnackbar(
          edit ? 'Notification rule details modified successfully !!' : 'Notification rule added successfully !!',
          { variant: 'success', preventDuplicate: true }
        );
        props.refresh();

        // props.refresh();
        return response1;
      })
      .catch(() => {
        enqueueSnackbar('Add Notification Rule action failed !!', { variant: 'error', preventDuplicate: true });
        // props.refresh();
      });
  };
  const getLatestValues = (dataObj: any) => {
    dataObj.parameters = [];
    if (dataObj.thresholdType === 'VALUE') {
      setNotificationValueDisable(true);
      const editData: any[] = [];
      (dataConfig || []).forEach((obj: any) => {
        let temp = { ...obj };
        if (temp.key === 'thresholdValue') {
          temp.disabled = true;
        }
        editData.push(temp);
      });
      dataConfig = [...editData];
    } else {
      setNotificationValueDisable(false);
      const editData: any[] = [];
      (dataConfig || []).forEach((obj: any) => {
        let temp = { ...obj };
        if (temp.key === 'thresholdValue') {
          temp.disabled = false;
        }
        editData.push(temp);
      });
      dataConfig = [...editData];
    }

    setFormInfo({ ...dataObj });
  };

  return (
    <div>
      <DialogForm
        key={'new-notification-dialog'}
        openFn={props.createNotificationDialog}
        closeFn={handleNotificationClose}
        dataConfig={notificationValueDisable ? dataConfig : AddNotificationFormDataConfig}
        handleDialogClose={handleNotificationClose}
        handleDialogSubmit={handleNotificationSubmit}
        submitlabel="Submit"
        dialogId={edit ? 'edit-notification-dialog' : 'new-notification-dialog'}
        title={props.edit ? 'Edit Notification Rule' : 'New Notification Rule'}
        getLatestValues={getLatestValues}
        data={formData}
        supportUser={props?.supportUser}
      ></DialogForm>
    </div>
  );
};
export default CreateNotificationDialog;
